import { caremeTheme } from "@/libs/theme";
import { TextField, type TextFieldProps } from "@mui/material";

export function EmailTextField(props: TextFieldProps) {
	return (
		<TextField
			margin="normal"
			required
			fullWidth
			variant="standard"
			placeholder="メールアドレス"
			name="email"
			autoComplete="email"
			autoFocus
			style={{ caretColor: caremeTheme.palette.primary.main }}
			inputProps={{
				pattern:
					"^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$",
				title: "有効なメールアドレスを入力してください",
			}}
			{...props}
		/>
	);
}
